import React, { useState } from "react";
import styles from "./SummaryTabs.module.css";
import { useNavigate } from "react-router-dom";
import HeaderComponent from "../../../../../components/HeaderComponent/HeaderComponent";
import TopTabComponent from "../../../../../components/TopTabComponent/TopTabComponent";
import SummaryPage from "../Instructions/SummaryPage";
import TabsOverview from "../Overview/Overview";
import HACCPCompliance from "../HACCPCompliance/HACCPCompliance";

const SummaryTabs = () => {
  const navigate = useNavigate();
  const tabOptions = [
    { id: 1, name: "Overview" },
    { id: 2, name: "HACCP Compliance" },
    { id: 3, name: "Instructions" },
  ];
  const [focusedTab, setFocusedTab] = useState(tabOptions[0]);

  return (
    <div className={styles.mainCont}>
      <HeaderComponent
        heading={"Process Name"}
        showBackIcon={true}
        showControlButtons={true}
      >
        <TopTabComponent
          options={tabOptions}
          focused={focusedTab}
          setFocused={setFocusedTab}
          TopTabListStyle={styles.TopTabListStyle}
        />
      </HeaderComponent>

      {focusedTab?.name === tabOptions[0].name ? (
        <TabsOverview />
      ) : focusedTab?.name === tabOptions[1].name ? (
        <HACCPCompliance />
      ) : focusedTab?.name === tabOptions[2].name ? (
        <SummaryPage />
      ) : null}
    </div>
  );
};

export default SummaryTabs;
